// extracted by css-extract-rspack-plugin
module.exports =  {"root":"dd07df66c4","petYear2022":"a38c5aaccc","active":"f53b04e860","petsshop":"b6e2239c42"};